<template>
  <div class="final-recap" style="display: block !important">
    <div style="display: none">{{ history }}</div>

    <div v-if="Object.keys(steps).length > 0" class="recap-content">
      <div>
        <div class="recap-header text-left">
          <h4>Récapitulatif de votre projet</h4>
        </div>
        <div class="recap-inner">
          <div
            v-for="(product, product_index) of products.filter(
              (prod) => !prod.deleted
            )"
            v-if="!product.deleted"
            class="history-wrapper"
          >
            <div
              class="history-header"
              v-if="product.history !== undefined && product.history.length > 1"
            >
              <h5 class="d-flex align-items-center">
                {{ product.history[0].value }} x
                {{ productQty(product.history) }}
                <!--<span class="qty-changer">

                                    <i class="fa fa-caret-up" @click="changeQty(product_index, productQty(product.history) +1)"></i>
                                    <i class="fa fa-caret-down" @click="changeQty(product_index, productQty(product.history) -1)"></i>
                                </span>-->
              </h5>

              <h5 v-if="pricesByProds[product_index]">
                PU :
                {{
                  (
                    parseFloat(pricesByProds[product_index]) /
                    parseInt(productQty(product.history))
                  ).toFixed(2)
                }}
                € TTC
              </h5>

              <div class="controls">
                <span
                  class="delais-popup-trigger"
                  v-if="imageRecapDelais(product.productType)"
                  @click="
                    fillAndOpenDefaultModal(
                      imageRecapDelais(product.productType)
                    )
                  "
                  >Délais</span
                >
                <span
                  class="garanties-popup-trigger"
                  v-if="imageRecapGaranties(product.productType)"
                  @click="
                    fillAndOpenDefaultModal(
                      imageRecapGaranties(product.productType)
                    )
                  "
                  >Garanties</span
                >
                <span @click.stop="togglebyIndex(product_index)"
                  >Détails du produit</span
                >
                <span
                  @click.stop="
                    openGlobalModal(
                      'Toute modification peut entrainer des changements techniques obligeant à sélectionner à nouveau les\n' +
                        '                caractéristiques du produit',
                      editProduct,
                      product_index
                    )
                  "
                  >Modifier</span
                >
                <span
                  @click.stop="
                    openGlobalModal(
                      'Êtes-vous sûr de vouloir supprimer cet élément ?',
                      deleteProduct,
                      product_index
                    )
                  "
                  >Supprimer</span
                >
              </div>
            </div>

            <div class="history-content-wrapper">
              <span
                v-for="(item, index) in getProductHistory(
                  product,
                  product_index
                )"
                class="history-content"
                v-if="!item.isGlobal"
              >
                <label>{{ item.label }}:&nbsp;</label>{{ item.value
                }}<span
                  class="history-comma"
                  v-if="
                    index !==
                    getProductHistory(product, product_index).length - 1
                  "
                  >,
                </span>
              </span>
            </div>
          </div>

          <div class="history-wrapper">
            <div class="history-header" v-if="globalAnswers.length > 1">
              <h5>Modalité de votre commande</h5>
            </div>
            <div class="history-content-wrapper">
              <span
                v-for="(item, index) in globalAnswers"
                class="history-content"
              >
                <label>{{ item.label }}:</label>
                {{ item.value }}
                <span
                  class="history-comma"
                  v-if="index !== globalAnswers.length - 1"
                  >,
                </span>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div class="col-md-12 col-sm-12S col-xs-10 row bandeau">
          <div class="row">
            <div class="col-md-4">
              <h3>
                <img
                  class="img-picto"
                  src="img/picto-fabrication-francaise.png"
                  alt="image pictogramme"
                />Fabrication 100% Française
              </h3>
            </div>
            <div class="col-md-4">
              <h3>
                <img
                  class="img-picto"
                  src="img/picto-suivi.png"
                  alt="image pictogramme"
                />
                Suivi & Accompagnement
              </h3>
            </div>
            <div class="col-md-4">
              <h3>
                <img
                  class="img-picto"
                  src="img/picto-sav.png"
                  alt="image pictogramme"
                />
                SAV & Garantie 10 ans
              </h3>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import history from "./mixins/history";

export default {
  name: "Recapitulatif",

  mixins: [history],
  data() {
    return {
      preventSave: null,
      showConfirm: false,
      projectName: this.$store.state.currentProjectName,
      order: false,
      priceByTva: {},
      totalReduction: 0,
      reductions: {},
      toggledProducts: [],
    };
  },
  watch: {
    projectName: function (newVal, oldVal) {
      this.$store.dispatch("setProjectName", newVal);
    },
  },
  computed: {
    pricesByProds() {
      return this.$store.state.priceByProds;
    },
    totalPrice() {
      let total = 0;
      Object.keys(this.products).forEach((key) => {
        if (!this.products[key].deleted) {
          let montantTva =
            this.products[key].price.toFixed(2) /
            (1 + this.products[key].tvaPercent / 100);
          let reduction = this.$store.state.reduction[
            this.products[key].productType
          ];

          montantTva = montantTva - (montantTva * reduction) / 100;
          total +=
            montantTva + (montantTva * this.products[key].tvaPercent) / 100;
        }
      });
      return total;
    },

    totalPriceHt() {
      let total = 0;
      this.priceByTva = {};
      this.totalReduction = 0;
      this.reductions = {};

      Object.keys(this.products).forEach((key) => {
        if (!this.products[key].deleted) {
          let montantTva =
            this.products[key].price.toFixed(2) /
            (1 + this.products[key].tvaPercent / 100);
          let reduction = this.$store.state.reduction[
            this.products[key].productType
          ];

          let reductionForProduct;
          total += montantTva - (montantTva * reduction) / 100;
          reductionForProduct = (montantTva * reduction) / 100;

          this.reductions[reduction] = this.reduction || 0;
          this.reductions[reduction] += reductionForProduct;

          this.totalReduction += reductionForProduct;
          if (
            this.priceByTva[this.products[key].tvaPercent.toString()] ===
            undefined
          ) {
            this.priceByTva[this.products[key].tvaPercent.toString()] = 0;
          }
          this.priceByTva[this.products[key].tvaPercent.toString()] +=
            ((montantTva - reductionForProduct) *
              this.products[key].tvaPercent) /
            100;
        }
      });
      return total;
    },

    tvaMode() {
      return Object.keys(this.products).length === 1
        ? this.$store.state.tvaMode
        : "TTC";
    },
    products() {
      return this.$store.state.products;
    },

    globalAnswers() {
      let globals = this.$store.state.globalAnswers
        .filter((item) => item.variable !== "other_prod")
        .map((item) => {
          return {
            label: item.name,
            value: item.label.replace(/(&nbsp;|<([^>]+)>)/gi, ""),
          };
        });

      globals.unshift({
        label: "Age de votre habitation",
        value: this.$store.state.olderThan2
          ? "Plus de 2 ans"
          : "Moins de deux ans",
      });
      globals.unshift({
        label: "Département",
        value: this.$store.state.departement,
      });

      return globals;
    },

    apiUrl() {
      return this.$store.state.apiUrl;
    },
    siteInfos() {
      return this.$store.state.siteInfos;
    },

    family() {
      return this.$store.state.family;
    },
  },
  created() {
    window.onbeforeunload = function (event) {

      // Cancel the event as stated by the standard.
      event.preventDefault();
      // Chrome requires returnValue to be set.
      event.returnValue = "";
    };
  },
  methods: {
    openGlobalModal(text, confirmFunc, arg) {
      const modal = $("#global-confirm-modal");
      modal.find("p").text(text);
      modal.find("#confirm-action").on("click", (e) => {
        e.preventDefault();
        modal.find("p").text("");
        modal.find("#confirm-action").off();
        modal.hide();
        confirmFunc(arg);
      });
      modal.show();
    },

    fillAndOpenDefaultModal(imageUrl) {
      imageUrl = `${this.apiUrl}/${imageUrl}`;
      let modal = $("#basicModal");
      modal.find("h5").text("");
      modal.find("img").attr("src", imageUrl);
      modal.find(".extra-popup").html("");
      modal.modal("show");
    },
    changeQty(product_index, value) {
      this.$store.dispatch("changeProductAnswerProperty", {
        product_index,
        variable: "quantite",
        value,
      });
    },
    togglebyIndex(index) {
      if (!this.toggledProducts.includes(index))
        this.toggledProducts.push(index);
      else this.toggledProducts.splice(this.toggledProducts.indexOf(index), 1);
    },
    getProductHistory(product, product_index) {
      let filtered = product.history.filter((el) => !el.isGlobal);
      if (!this.toggledProducts.includes(product_index))
        filtered = filtered.filter((el) => {
          if (el.label === undefined) {
            return false;
          }
          return (
            (!el.label.toLowerCase().includes("imposte") &&
              !el.label.toLowerCase().includes("allège") &&
              el.label.toLowerCase().includes("hauteur")) ||
            el.label.toLowerCase().includes("largeur")
          );
        });

      return filtered;
    },

    recapImageUrl(product) {
      let famille = this.$store.state.families.find((e) => {
        return e.Prefix === product.productType;
      });
      if (famille) return `${this.$store.state.apiUrl}/${famille.image_recap}`;

      return "";
    },
    editProduct(key) {
      this.$store.dispatch("loadProduct", key);
    },
    deleteProduct(key) {
      this.$store.dispatch("deleteProduct", key).then((whereTo) => {
        if (whereTo === "goHome") {
          this.$router.push("/preconstructor");
        }
      });
    },

    productQty(history) {
      let qty = history.find((res) => res.label === "Quantité");
      if (qty) return parseInt(qty.value);
      else return "";
    },
    precision_recap(productType) {
      let famille = this.$store.state.families.find((e) => {
        return e.Prefix === productType;
      });
      if (famille) return famille.precision_recap;

      return null;
    },
    imageRecapDelais(productType) {
      let famille = this.$store.state.families.find((e) => {
        return e.Prefix === productType;
      });
      if (famille) return famille.image_recap_delais;

      return false;
    },
    imageRecapGaranties(productType) {
      let famille = this.$store.state.families.find((e) => {
        return e.Prefix === productType;
      });
      if (famille) return famille.image_recap_garanties;

      return false;
    },
  },
};
</script>

<style scoped>
.controls {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.delais-popup-trigger,
.garanties-popup-trigger {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 10px;
  min-width: 65px;
}

.garanties-popup-trigger {
  background: #0a0c0d;
  color: #ffffff;
  margin-left: 0 !important;
}

.row {
  margin-left: 0% !important;
}

.qty-changer {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-left: 10px;
}

.qty-changer i {
  font-size: 24px;
  cursor: pointer;
  transition: all 0.2s linear;
  min-height: 50%;
}

.qty-changer i:hover,
.qty-changer i:focus {
}

.wrapped {
  max-height: 0;
}

.bandeau {
  padding: 25px 10px;
  width: auto;
}

.img-picto {
  width: 13%;
  margin-right: 10px;
}

.col-md-4 {
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
}

h3 {
  font-size: 1.163rem;
  display: table-cell;
  vertical-align: middle;
  text-align: center;
  padding: 10px;
  font-weight: bold;
  line-height: initial;
}

.recap-inner {
  padding: 20px;
  background: #ffffff;
  overflow-y: scroll;
}

.recap-header {
  width: 100%;
  background: #f5f4f4;
  padding: 20px 60px;
}

.history-wrapper {
  text-align: left;
  border: solid 2px #f5f4f4;
  margin-bottom: 30px;
}

.history-header {
  width: 100%;
  background: #f5f4f4;
  padding: 0px 20px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.history-header h5 {
  margin: 0;
  font-size: 16px;
}

.history-header span:not(.qty-changer) {
  margin-left: 20px;
  font-size: 14px;
  font-weight: bold;
  text-decoration: underline;
  cursor: pointer;
}

.history-content-wrapper {
  padding: 20px;
}

h4 {
  margin: 0;
  font-weight: bold;
}

ol {
  text-align: left;
}

.no-effects,
.no-effects:hover,
.no-effects:focus {
  color: #ffffff;
  text-decoration: none;
}

.choice img {
  width: 50px;
}

.choice {
  margin-right: 0 !important;
  justify-content: space-around;
  min-width: 275px;

  font-weight: bold;
  font-size: 1.3em;
}

.history-content {
  width: auto;
}

.history-content label {
  font-weight: bold;
}

.price-container {
  justify-content: center;
  display: flex;
  margin-bottom: 60px;
}

.line-price {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  width: 70%;
  font-size: 18px;
  padding-bottom: 10px;
  margin-top: 15px;
  border-bottom: none;
  justify-content: flex-end;
}

.card-container {
  height: 100%;
}

.recap-content {
  /* height: 65vh; */
  width: 100%;
  height: 100%;
  min-height: 80vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  overflow: auto;
}

.recap-btn {
  height: 10%;
  padding: 10px;
  display: flex;
  justify-content: space-around;
}

.recap-btn button {
  background: rgba(101, 169, 169, 1);
  border: none;
  -webkit-box-shadow: none;
  box-shadow: none;
  cursor: pointer;
  padding: 10px 15px;
  color: #fff;
}

.circle i {
  display: inline-block;
  width: 18px;
  height: 18px;
  border-radius: 50%;
}

span > i {
  font-style: normal;
}

.img_pvc_product {
  width: 50%;
}

@media screen and (min-width: 1024px) and (max-width: 1400px) {
  .popup-valid {
    width: 60%;
  }

  .choice {
    max-width: 200px;
    min-width: 200px;
  }

  .choice > p {
    font-size: 16px;
    /*width: 60%;*/
  }

  .choice img {
    width: 40px;
  }
}

@media screen and (max-width: 1023px) {
  .recap-btn {
    flex-wrap: wrap;
    align-items: center;
  }

  .choice {
    max-width: 45%;
    min-width: 45%;
    margin-bottom: 20px;
    height: 125px;
  }

  .choice > p {
    width: 100%;
  }

  .choice-img {
    display: none;
  }

  .line-price {
    justify-content: center;
  }
}

@media screen and (max-width: 1023px) {
  .choice img {
    display: none;
  }

  .popup-valid {
    position: fixed;
    width: 80%;
    top: 100%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    -moz-transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    -o-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);

    margin: 0;
  }
}

@media screen and (min-width: 768px) and (max-width: 1023px) {
  .choice p {
    margin-right: 8%;
    margin-top: -3%;
  }
}

@media screen and (max-width: 1200px) {
  .img_pvc_product {
    display: none;
  }
}

@media screen and (max-width: 1200px) and (min-width: 575px) {
  .history-header span:not(.qty-changer) {
    margin-left: 10px;
    font-size: 11px;
  }

  .history-header h5 {
    font-size: 11px;
  }

  .history-header {
    padding: 0px 10px;
  }

  .history-content-wrapper {
    padding: 10px;
  }

  .history-content {
    font-size: 0.7rem;
  }
}

@media screen and (max-width: 520px) {
  .choice img {
    display: none;
  }

  .choice p {
    font-size: 16px;
    margin-top: -10px;
  }
}
</style>
